import React, { Component } from 'react';
import Header from '../Inc/Layout/Header.js';
import Footer from '../Inc/Layout/Footer.js';
import DocumentMeta from 'react-document-meta';
import { message } from '../../_constants';
import { Button } from 'react-bootstrap';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { getAllHome } from '../../actions/home';
import locateImage from '../../image/locator.png';
import loadingLocation from "../../image/locationMarker.gif"
import { getAllCityByCountryAction, getAllCityAction, getAllCountryAction } from '../../actions/FindRecCompany';
import Select from 'react-select';
import $ from 'jquery';
let fieldsArr = [];
let className = "";

class LandingPage extends Component {
    constructor(props) {
        super(props);
        this.state = {
            fieldsList: JSON.parse(localStorage.getItem('categoryArr')) ? JSON.parse(localStorage.getItem('categoryArr')) : [],
            cityOption: [],
            citySeacrh: JSON.parse(localStorage.getItem('locationCity')) ? JSON.parse(localStorage.getItem('locationCity')) : { "label": "All", value: "all" },
            cityData:[],
            countryOption: [],
            code: '',
            city: '',
            radioSearchCity: '',
            searchCordinate: '',
            fieldSelct: [],
            countrySelect: JSON.parse(localStorage.getItem('locationCountry'))
        }
    };

    componentWillMount() {
        const userData = JSON.parse(localStorage.getItem('userData'))
        if ((userData && userData.userType === "company") || (userData && userData.userType === "recruiter")) {
            this.props.history.push({
                pathname: "/dashboard-home",
            });
        }

        let reqObj = {
            "limit": 1000,
            "offset": 0,
            "order": "orderby",
            "direction": "asc",
            "search": "",
            "status": ""
        }
        this.props.getAllHome(reqObj);
        this.props.getAllCityAction()
        this.props.getAllCountryAction()
    }

    setCityLocaltion(cityArr){
        if(localStorage.getItem("defaultCity")){
            for(let x in cityArr){
                if(cityArr[x].cityName == localStorage.getItem("defaultCity")){
                    this.setState({
                        citySeacrh: {label:cityArr[x].cityName, value:cityArr[x]._id},
                       // requestServer: true,
                        radioSearchCity: cityArr[x].cityName
                    });

                    localStorage.setItem("changeCity", true)
                    localStorage.setItem("locationCity", JSON.stringify({label:cityArr[x].cityName, value:cityArr[x]._id}));
                    localStorage.setItem("defaultCity", cityArr[x].cityName);
                    var coordinate = cityArr[x].coordinates
                    localStorage.setItem("coordinate", JSON.stringify(coordinate));
                    this.setState({
                       searchCordinate: coordinate,
                    })
                }
            }
        }
    }

    componentWillReceiveProps(nextProps) {
        const { fieldSelct } = this.state
        if (nextProps && nextProps.city && nextProps.city !== "") {
            this.setState({
                city: sessionStorage.getItem('defaultCity')
            })
            let reqObj = {}
            reqObj["search"] = nextProps.city;
            if (fieldSelct.length > 0) {
                reqObj["fieldSelct"] = fieldSelct;
                reqObj["userType"] = "all"
                this.props.history.push({
                    pathname: this.props.auth.cityUrlFunction("/search-result"),
                    state: { "reqObj": reqObj }
                });
            } else {
                this.props.auth.error(message.fieldSelect);
            }
        }
        if (nextProps && nextProps.fields && nextProps.fields.length > 0) {
            const fieldsList = localStorage.getItem('categoryArr') ? localStorage.getItem('categoryArr') : "";
            if (fieldsList !== JSON.stringify(nextProps.fields)) {
                localStorage.setItem("categoryArr", JSON.stringify(nextProps.fields))
                this.setState({
                    fieldsList: nextProps.fields
                })
            }
        }
        if (nextProps && nextProps.responseCountry && nextProps.responseCountry.statusCode === 200) {
            var countryData = nextProps.responseCountry.data && nextProps.responseCountry.data.data
            let countryArr = [];
            for (var x in countryData) {
                for (var y in countryData[x].countryName) {
                    countryData[x].countryName[y]
                    let obj = {};
                    obj.label = countryData[x].countryName[y].label;
                    obj.value = countryData[x].countryName[y].value;
                    countryArr.push(obj);
                }
            }
            this.setState({
                countryOption: countryArr
            })
        }

        if (nextProps && nextProps.responseCityByCountry && nextProps.responseCityByCountry.statusCode === 200) {
            let cityData = nextProps.responseCityByCountry.cityData && nextProps.responseCityByCountry.cityData.data
            let cityArr = [];
            for (let m in cityData) {
                let obj = {};
                obj.label = cityData[m].cityName;
                obj.value = cityData[m]._id;
                cityArr.push(obj);
            }
            this.setState({
                cityOption: cityArr
            })
        }
        if (nextProps && nextProps.allCitySuggetion && nextProps.allCitySuggetion.statusCode === 200) {
            let cityData = nextProps.allCitySuggetion.cityData && nextProps.allCitySuggetion.cityData.data
            let cityArr = [];
            for (let z in cityData) {
                let obj = {};
                obj.label = cityData[z].cityName;
                obj.value = cityData[z]._id;
                cityArr.push(obj);
            }

            this.setState({
                cityData:cityData,
                cityOption: cityArr
            },this.setCityLocaltion(cityData))
        }

        if (nextProps && nextProps.allCitySuggetion && nextProps.allCitySuggetion.statusCode === 500) {
            this.setState({
                cityOption: [{ label: "No Data", value: "No Data" }]
            })
        }
    }

    handleChangeSelect = async (name, value) => {
        this.setState({
            [name]: value,
            requestServer: true,
            radioSearchCity: value.label
        });
        setTimeout(
            function() {
                this.setState({ requestServer: false });
            }
            .bind(this),
            700
        );

        if (name === "citySeacrh" && value && value.label) {
            let cityData = this.state.cityData;
            let indexof = cityData.findIndex(cityType => cityType._id === value.value);
            if(indexof > -1){
                localStorage.setItem("changeCity", true)
                localStorage.setItem("locationCity", JSON.stringify(value));
                localStorage.setItem("defaultCity", value.label);
                var coordinate = cityData[indexof].coordinates
                localStorage.setItem("coordinate", JSON.stringify(coordinate));
                this.setState({
                    searchCordinate: coordinate,
                })
                this.props.history.push({
                    pathname: this.props.auth.cityUrlFunction(),
                    state: { "reqObj": {} }
                });
            }

        }
    }

    fields() {
        fieldsArr = [];
        const fieldsList = JSON.parse(localStorage.getItem('categoryArr')) ? JSON.parse(localStorage.getItem('categoryArr')) : [];
        var i = 0;
        if (fieldsList) {
            for (i in fieldsList) {
                fieldsArr.push(
                    <div className="custom-style spc-labels" key={i}>
                        <input type="checkbox" className="new-chkbox" name="fields" id={fieldsList[i]._id} onClick={this.handleChangeCheckBox.bind(fieldsList[i]._id)} value={fieldsList[i]._id}  />
                        <label htmlFor={fieldsList[i]._id}>{fieldsList[i].name}</label>
                    </div>
                )
            }
        }
    }

    handleChangeCheckBox = (e, id) => {
        const { fieldSelct } = this.state
        if (document.getElementById(e.target.value).checked === true) {
            fieldSelct.push(e.target.value)
        } else {
            var index = fieldSelct.indexOf(e.target.value);
            if (index > -1) {
                fieldSelct.splice(index, 1);
            }
        }
        this.setState({
            fieldSelct: fieldSelct
        })
    }

    handleChangeradioForCity = (city, latlong, e) => {
        this.setState({
            radioSearchCity: city,
            searchCordinate: latlong
        })
    }

    findData = (searchBY, e) => {
        const { city, fieldSelct, radioSearchCity, searchCordinate } = this.state
        let reqObj = {}
        
        if (fieldSelct.length > 0) {
            reqObj["fieldSelct"] = fieldSelct;
            if (city) {
                reqObj["search"] = city;
            } else {
                reqObj["search"] = "all";
            }

            reqObj["userType"] = "all"
            if (searchBY === "recruiter") {
                reqObj["userType"] = "recruiter";
            }
            if (searchBY === "company") {
                reqObj["userType"] = "company";
            }

            reqObj.radioSearchCity = radioSearchCity
            reqObj.searchCordinate = searchCordinate
            if (searchBY === "job") {
                reqObj["userType"] = "company";
                this.props.history.push({
                    pathname: this.props.auth.cityUrlFunction("/search-jobs"),
                    state: { "reqObj": reqObj }
                });
            } else {
                this.props.history.push({
                    pathname: this.props.auth.cityUrlFunction("/search-result"),
                    state: { "reqObj": reqObj }
                })
            }
        } else {
            this.props.auth.error(message.fieldSelect);
        }

    }

    ChangeCountry = () => {

        $('#countrySeacrh input').focus();
    }

    ChangeCity = () => {
        $('#citySeacrh input').focus();
        localStorage.setItem("changeCity", true)
    }

    render() {
        const { requestServer } = this.state;

        if (requestServer) {
            className = "pageloading";
        } else {
            className = "";
        }
        const fieldsList = JSON.parse(localStorage.getItem('categoryArr')) ? JSON.parse(localStorage.getItem('categoryArr')) : [];

        const meta = {
            title: 'Right Connection - Recruitment Service Network',
            description: 'Right Connection is the pioneer of an organized Recruitment Service Network in various cities including Los Angeles, San Francisco, San Diego, New York and more.',
            canonical: '<link rel="canonical" href=" https://arightconnection.com/ " data-rdm="">',
            meta: {
                charset: 'utf-8',
                name: {
                    keywords: 'Information Technology Recruiter Los Angeles, Information Technology Recruitment Services Los Angeles, Technical Recruiter Los Angeles, Technical Recruitment Services Los Angeles, Product Management Recruiter Los Angeles, Product Management Recruitment Services Los Angeles, C-Level Recruiter Los Angeles, C-Level Recruitment Services Los Angeles, Leadership Recruiters Los Angeles, Leadership Recruitment Services Los Angeles, Accounting Recruiter Los Angeles, Accounting Recruitment Services Los Angeles, Finance Recruiter Los Angeles, Finance Recruitment Services Los Angeles, Accounting & Finance Recruiter Los Angeles, Accounting & Finance Recruitment Services Los Angeles, Sales & Marketing Recruiter Los Angeles, Sales & Marketing Recruitment Services Los Angeles, Marketing Recruiter Los Angeles, Marketing Recruitment Services Los Angeles, Sales Recruitment Los Angeles, Sales Recruitment Services Los Angeles, Career Coaching Services Los Angeles, Creatives Recruiter Los Angeles, Creatives Recruitment Services Los Angeles, , Information Technology Recruiter New York, Information Technology Recruitment Services New York, Technical Recruiter New York, Technical Recruitment Services New York, Product Management Recruiter New York, Product Management Recruitment Services New York, C-Level Recruiter New York, C-Level Recruitment Services New York, Leadership Recruiters New York, Leadership Recruitment Services New York, Accounting Recruiter New York, Accounting Recruitment Services New York, Finance Recruiter New York, Finance Recruitment Services New York, Accounting & Finance Recruiter New York, Accounting & Finance Recruitment Services New York, Sales & Marketing Recruiter New York, Sales & Marketing Recruitment Services New York, Marketing Recruiter New York, Marketing Recruitment Services New York, Sales Recruitment New York, Sales Recruitment Services New York, Career Coaching Services New York, Creatives Recruiter New York, Creatives Recruitment Services New York, , , Information Technology Recruiter Seattle, Information Technology Recruitment Services Seattle, Technical Recruiter Seattle, Technical Recruitment Services Seattle, Product Management Recruiter Seattle, Product Management Recruitment Services Seattle, C-Level Recruiter Seattle, C-Level Recruitment Services Seattle, Leadership Recruiters Seattle, Leadership Recruitment Services Seattle, Accounting Recruiter Seattle, Accounting Recruitment Services Seattle, Finance Recruiter Seattle, Finance Recruitment Services Seattle, Accounting & Finance Recruiter Seattle, Accounting & Finance Recruitment Services Seattle, Sales & Marketing Recruiter Seattle, Sales & Marketing Recruitment Services Seattle, Marketing Recruiter Seattle, Marketing Recruitment Services Seattle, Sales Recruitment Seattle, Sales Recruitment Services Seattle, Career Coaching Services Seattle, Creatives Recruiter Seattle, Creatives Recruitment Services Seattle, , Information Technology Recruiter Portland, Information Technology Recruitment Services Portland, Technical Recruiter Portland, Technical Recruitment Services Portland, Product Management Recruiter Portland, Product Management Recruitment Services Portland, C-Level Recruiter Portland, C-Level Recruitment Services Portland, Leadership Recruiters Portland, Leadership Recruitment Services Portland, Accounting Recruiter Portland, Accounting Recruitment Services Portland, Finance Recruiter Portland, Finance Recruitment Services Portland, Accounting & Finance Recruiter Portland, Accounting & Finance Recruitment Services Portland, Sales & Marketing Recruiter Portland, Sales & Marketing Recruitment Services Portland, Marketing Recruiter Portland, Marketing Recruitment Services Portland, Sales Recruitment Portland, Sales Recruitment Services Portland, Career Coaching Services Portland, Creatives Recruiter Portland, Creatives Recruitment Services Portland, , Information Technology Recruiter San Diego, Information Technology Recruitment Services San Diego, Technical Recruiter San Diego, Technical Recruitment Services San Diego, Product Management Recruiter San Diego, Product Management Recruitment Services San Diego, C-Level Recruiter San Diego, C-Level Recruitment Services San Diego, Leadership Recruiters San Diego, Leadership Recruitment Services San Diego, Accounting Recruiter San Diego, Accounting Recruitment Services San Diego, Finance Recruiter San Diego, Finance Recruitment Services San Diego, Accounting & Finance Recruiter San Diego, Accounting & Finance Recruitment Services San Diego, Sales & Marketing Recruiter San Diego, Sales & Marketing Recruitment Services San Diego, Marketing Recruiter San Diego, Marketing Recruitment Services San Diego, Sales Recruitment San Diego, Sales Recruitment Services San Diego, Career Coaching Services San Diego, Creatives Recruiter San Diego, Creatives Recruitment Services San Diego, , Information Technology Recruiter San Francisco, Information Technology Recruitment Services San Francisco, Technical Recruiter San Francisco, Technical Recruitment Services San Francisco, Product Management Recruiter San Francisco, Product Management Recruitment Services San Francisco, C-Level Recruiter San Francisco, C-Level Recruitment Services San Francisco, Leadership Recruiters San Francisco, Leadership Recruitment Services San Francisco, Accounting Recruiter San Francisco, Accounting Recruitment Services San Francisco, Finance Recruiter San Francisco, Finance Recruitment Services San Francisco, Accounting & Finance Recruiter San Francisco, Accounting & Finance Recruitment Services San Francisco, Sales & Marketing Recruiter San Francisco, Sales & Marketing Recruitment Services San Francisco, Marketing Recruiter San Francisco, Marketing Recruitment Services San Francisco, Sales Recruitment San Francisco, Sales Recruitment Services San Francisco, Career Coaching Services San Francisco, Creatives Recruiter San Francisco, Creatives Recruitment Services San Francisco,'
                }
            }
        };
        return (
            <div>
            <div className={"pageForLoading "+className}>
                   <div className="wrap">
                        <div className="loading">
                            <img src={loadingLocation} alt="Location"/>
                        </div>
                    </div>
                </div>
             
            <div className="home-wrapper">
            <DocumentMeta {...meta}>
                <title>Right Connection</title>
                <meta name="description" content="Some description." />
                <meta property="og:title" content="MyApp" />
                <meta property="og:image" content="path/to/image.jpg" />
            </DocumentMeta>
            <div className="bg-right">
                <Header props={ this.props } />
                <div className="body-wrapper">
                    <div className="container">
                        <div className="main-content content-main">
                            <div className="row ">
                                <div className="col-md-8">
                                    <h2 className="top-titleb">A Right Connection can change your life!</h2>
                                            <h3 className="top-sub-title">We help you connect with Recruiters / Career Coach / Advisor </h3>
                                </div>
                                <div className="col-md-8">
                                    <div className="">
                                       {fieldsList.map((category, idx) => (
                                            <div className="custom-style spc-labels" key={idx}>
                                                <input type="checkbox" className="new-chkbox" name="fields" id={category._id} onClick={this.handleChangeCheckBox.bind(category._id)} value={category._id}  />
                                                <label htmlFor={category._id}>{category.name}</label>
                                            </div>
                                        ))}
                                    </div>
                                </div>
                                <input id="searchTextField" />
                                <div className="col-md-12 spc-mob">
                                    <div className="row">
                                        <div className="col-md-8 col-lg-5 btn-align">
                                            <Button className="btn1 camp-btn" onClick={this.findData.bind(this,"recruiter")}> Find &nbsp; <i class="fa fa-search" aria-hidden="true"></i></Button>
                                        {/* <Button className="btn1 camp-btn" onClick={this.findData.bind(this,"company")}> Find A Company
                                               
                                            </Button>                                            
                                            <Button className="btn1 camp-btn" onClick={this.findData.bind(this,"job")}> Find A Job
                                               
                                            </Button>*/}
                                        </div>
                                      {/*  <div className="col-md-7 col-lg-4 flxalinG">
                                            <div className="spc-bbb locate">
                                                <span>Your current search defaults to</span>
                                                <span className="dfultCity">{localStorage.getItem("defaultCity")}</span>
                                            </div>
                                            <div className="location-box location-all">
                                                <div className="block-v">
                                                    <span className="input-group-addon">
                                                        <img className="locate-image post-ab" src={locateImage} alt=""/>
                                                    </span>
                                                </div>
                                                <div className="row">
                                                    <div className="col-md-11 sZelet-search">
                                                        <Select id="citySeacrh" name="citySeacrh" className="singup-control home-serh" value={this.state.citySeacrh} onChange={this.handleChangeSelect.bind(this, "citySeacrh" )} options={this.state.cityOption} placeholder="Select City" />
                                                        <span className="change-city-b" onClick={()=>this.ChangeCity()}>Change City</span>
                                                    </div>
                                                </div>
                                                
                                            </div>
                                        </div>*/} 
                                        </div>
                                
                                        <div className="row">
                                            {/*<div className="col-md-12  col-lg-12 flxalinG">
                                                <div className="spc-bbb locate">
                                                    <span>Your current search defaults to</span>
                                                    <span className="dfultCity">{localStorage.getItem("defaultCity")}</span>
                                                </div>
                                            </div>*/}
                                            
                                            <div className="col-md-3">
                                                <div className="block-v">
                                                    <span className="input-group-addon">
                                                       <img className="locate-image post-ab" src={locateImage} alt=""/>
                                                    </span>
                                                </div>
                                                <Select id="citySeacrh" name="citySeacrh" className="singup-control home-serh Left_Search" value={this.state.citySeacrh} onChange={this.handleChangeSelect.bind(this, "citySeacrh" )} options={this.state.cityOption} placeholder="Select City" />
                                                <span className="change-city-b" onClick={()=>this.ChangeCity()}>Change City</span>  
                                                {/*<Select id="countrySeacrh" name="countrySeacrh" className="singup-control home-serh Left_Search" value={this.state.countrySelect} onChange={this.handleChangeSelect.bind(this, "countrySelect" )} options={countryOption} placeholder="Select Country" />*/}
                                                {/*<span className="change-city-b" onClick={()=>this.ChangeCountry()}>Change Country</span>*/}
                                            </div> 

                                            {/*<div className="col-md-3">
                                                <Select id="citySeacrh" name="citySeacrh" className="singup-control home-serh" value={this.state.citySeacrh} onChange={this.handleChangeSelect.bind(this, "citySeacrh" )} options={this.state.cityOption} placeholder="Select City" />
                                                <span className="change-city-b" onClick={()=>this.ChangeCity()}>Change City</span>
                                            </div>*/}
                                        </div>   
                                </div>
                            </div>
                        </div>
                    </div>
              
                </div>
            </div>
            <Footer/>
        </div>
        </div>
        );
    }
}


function mapStateToProps(state) {
    return {
        allCitySuggetion: state.FindRecCompany.allCitySuggetion,
        responseCityByCountry: state.FindRecCompany && state.FindRecCompany.responseCityByCountry,
        responseCountry: state.FindRecCompany && state.FindRecCompany.responseCountry,
        fields: state.home.response.data,
        city: state.FindRecCompany.city
    };
}


export default withRouter(connect(mapStateToProps, {
    getAllHome,
    getAllCountryAction,
    getAllCityAction,
    getAllCityByCountryAction
})(LandingPage));


// WEBPACK FOOTER //
// ./src/components/HomePage/LandingPage.js